import instanceAxios from './axiosConfig';
import { URL } from '../utility/util';

const getCannedMsgAPI = async (site) => {

  let req = URL.PARAMS.GET_CANNED_MESSAGES;
  req.site = site;
  return new Promise((resolve, reject) => {
    instanceAxios.post('/mso-chat', req)
      .then((response) => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      })
  })

};



const storeCannnedMsgDetails = async (cannedMsgAttributes) => {
  let req = URL.PARAMS.STORE_CANNED_MSG_DETAILS;
  req.data = cannedMsgAttributes;
  return new Promise((resolve, reject) => {
    instanceAxios.post('/mso-chat', req)
      .then((response) => {
        console.log("response", response);
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error);
      })
  })
};



export { getCannedMsgAPI, storeCannnedMsgDetails };